import { render, staticRenderFns } from "./menu-card.vue?vue&type=template&id=4a48737a&scoped=true&"
import script from "./menu-card.vue?vue&type=script&lang=js&"
export * from "./menu-card.vue?vue&type=script&lang=js&"
import style0 from "./menu-card.vue?vue&type=style&index=0&id=4a48737a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a48737a",
  null
  
)

export default component.exports